module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic14.ce510564.png";